var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container-tooltip" }, [
    _c(
      "div",
      { ref: "masterContent", staticClass: "content" },
      [_vm._t("default")],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        ref: "messageContent",
        staticClass: "message",
        style: _vm.messageStyle
      },
      [_vm._t("message", [_vm._v(_vm._s(_vm.message))])],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-672ad6d5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-672ad6d5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/custom/Tooltip.vue
// module id = null
// module chunks = 